<template>
    <div>
        <!-- 功能按钮 -->
        <buttonlist @add="add" @search="search" @reflash="reflash" @exps="exp" @del="delall" @imp='imp'
                    ref="SetBtn"></buttonlist>
        <!-- 功能按钮 -->
        <div style="margin-top: 9px;margin-bottom: 3px;">
            <el-row>
                <el-col :span="6" style="text-align: left">

                </el-col>
                <el-col :span="12" style="text-align: left">
                    <span style="padding:0 20px;">{{$t('getapi[506]')}}</span>
                    <el-select filterable v-model="comboxList.value" size="mini"
                               style="margin-righ:20px">
                        <el-option v-for="item in comboxList.Rows" :key="item.value" :label="item.label"
                                   :value="item.value">
                            <span style="float: left">{{ item.label }}</span>
                            <span style="float: right; color: #8492a6; font-size: 9px">{{ item.type }}</span>
                        </el-option>
                    </el-select>
                    <!-- <el-option-group v-for="group in comboxList.Rows" :key="group.label" :label="group.label">
                            <el-option v-for="item in group.items" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-option-group> -->
                    <el-button type="primary" size="mini" @click="updateComboxList" style="margin-left: 15px;">{{$t('getapi[8738]')}}
                    </el-button>
                </el-col>
            </el-row>
        </div>

        <!-- 表格 -->
        <el-table id="xpane-0" ref="multipleTable" :data="dataSet" v-loading="loading" :highlight-current-row="false"
                  show-overflow-tooltip="true" border stripe size="mini" header-row-class-name="headerclass"
                  :height="tableHeight" @cell-dblclick="cellDBClick"
                  tab-click="selectInfo(0)" @selection-change="handleSelectionChange"
                  style="width: 100%; margin-top:0px" @sort-change="sortChange"
                  :header-cell-style="$limits.headerClass">
            <el-table-column type="selection"></el-table-column>
            <!-- <el-table-column show-overflow-tooltip prop='exclusively_id' label='Key' title='Key'></el-table-column> -->
            <el-table-column show-overflow-tooltip prop='csr_id' :label="$t('getapi[2610]')" title='客户代码' fixed
                             sortable="custom"></el-table-column>
            <el-table-column show-overflow-tooltip prop='csr_partcode' :label="$t('getapi[3038]')" title='客户零件' fixed
                             sortable="custom"></el-table-column>
            <el-table-column show-overflow-tooltip prop="relation_order_no" :label="$t('getapi[2095]')" title="单据编号"
                             fixed width="120" sortable="custom">
            </el-table-column>
            <el-table-column prop='part_code' :label="$t('getapi[8146]')" title='伟泰料号' fixed width="120"
                             sortable="custom">
                <template slot-scope="scope">
                    <el-link style="padding-left: 3px;" :underline="false" type="primary" href="javascript:void(0)"
                             @click.native.prevent="dialog_show(scope)">{{scope.row.part_code}}
                    </el-link>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop='sort_id' :label="$t('getapi[1297]')" title='序号' align="center"
                             sortable="custom"></el-table-column>
            <el-table-column show-overflow-tooltip prop='mp_text' :label="$t('getapi[6117]')" title='物料类型'
                             sortable="custom"></el-table-column>
            <el-table-column show-overflow-tooltip prop='leadtime_line' :label="$t('getapi[8156]')" title='周期小计(天)' align="right"
                             sortable="custom"></el-table-column>
            <el-table-column show-overflow-tooltip :class-name="fmtComboxList('level_no')" prop='level_no' :label="$t('getapi[8148]')"
                             title='层级' align="right" sortable="custom">
                <template scope="scope">
					<span v-if="comboxList.value == 'level_no'">
						<el-input class-name="check" size="small" v-model="scope.row.level_no"
                                  @change="afterChangeToRow(scope)" type="number" autocomplete="off" title="" @mousewheel.native.prevent></el-input>
					</span>
                    <span v-else>
						{{ scope.row.level_no}}
					</span>
                </template>
            </el-table-column>
            <el-table-column :class-name="fmtComboxList('std_qty')" prop='std_qty' :label="$t('getapi[4347]')"
                             title='BOM用量' align="right">
                <template scope="scope">
					<span v-if="comboxList.value == 'std_qty'">
						<el-input class-name="check" size="small" v-model="scope.row.std_qty"
                                  @change="afterChangeToRow(scope)" type="number" autocomplete="off" title="" @mousewheel.native.prevent></el-input>
					</span>
                    <span v-else>
						{{ scope.row.std_qty}}
					</span>
                </template>
            </el-table-column>
            <el-table-column :class-name="fmtComboxList('mould_text')" prop='mould_text'
                             :label="$t('getapi[8153]')" title='是否需要工装模具' sortable="custom">
                <template scope="scope">
					<span v-if="comboxList.value == 'mould_text'">
						<el-input class-name="check" size="small" v-model="scope.row.mould_text"
                                  @change="afterChangeToRow(scope)"></el-input>
					</span>
                    <span v-else>
						{{ scope.row.mould_text}}
					</span>
                </template>
            </el-table-column>

            <el-table-column :class-name="fmtComboxList('leadtime_purchase')"
                             prop='leadtime_purchase' :label="$t('getapi[1520]')" title='采购周期(天)' align="right" sortable="custom">
                <template scope="scope">
					<span v-if="comboxList.value == 'leadtime_purchase'">
						<el-input class-name="check" size="small" v-model="scope.row.leadtime_purchase" type="number" autocomplete="off" title=""
                                  @mousewheel.native.prevent @change="afterChangeToRow(scope)"></el-input>
					</span>
                    <span v-else>
						{{ scope.row.leadtime_purchase}}
					</span>
                </template>
            </el-table-column>
            <el-table-column :class-name="fmtComboxList('leadtime_produce')"
                             prop='leadtime_produce' :label="$t('getapi[8137]')" title='制造周期(天)' align="right" sortable="custom">
                <template scope="scope">
					<span v-if="comboxList.value == 'leadtime_produce'">
						<el-input class-name="check" size="small" v-model="scope.row.leadtime_produce" type="number" autocomplete="off" title=""
                                  @mousewheel.native.prevent @change="afterChangeToRow(scope)"></el-input>
					</span>
                    <span v-else>
						{{ scope.row.leadtime_produce }}
					</span>
                </template>
            </el-table-column>
            <el-table-column :class-name="fmtComboxList('leadtime_mold')" prop='leadtime_mold'
                             :label="$t('getapi[8138]')" title='工装模具周期(天)' align="right" sortable="custom">
                <template scope="scope">
					<span v-if="comboxList.value == 'leadtime_mold'">
						<el-input class-name="check" size="small" v-model="scope.row.leadtime_mold" type="number" autocomplete="off" title=""
                                  @mousewheel.native.prevent @change="afterChangeToRow(scope)"></el-input>
					</span>
                    <span v-else>
						{{ scope.row.leadtime_mold }}
					</span>
                </template>
            </el-table-column>
            <el-table-column prop='line_status' :label="$t('getapi[552]')" title='行状态(生成、已评估）'
                             sortable="custom"></el-table-column>

            <el-table-column :class-name="fmtComboxList('routing_flag')" prop='routing_flag'
                             :label="$t('getapi[8147]')" title='工艺有无(-不需要,Yes,No)' sortable="custom">
                <template scope="scope">
					<span v-if="comboxList.value == 'routing_flag'">
						<el-input class-name="check" size="small" v-model="scope.row.routing_flag" placeholder="Y/-/N"
                                  @change="afterChangeToRow(scope)"></el-input>
					</span>
                    <span v-else>
						{{ scope.row.routing_flag}}
					</span>
                </template>
            </el-table-column>
            <el-table-column :class-name="fmtComboxList('pur_quotation_flag')"
                             prop='pur_quotation_flag' :label="$t('getapi[449]')" title='采购价表(-不需要,Yes,No)' sortable="custom">
                <template scope="scope">
					<span v-if="comboxList.value == 'pur_quotation_flag'">
						<el-input class-name="check" size="small" v-model="scope.row.pur_quotation_flag"
                                  placeholder="Y/-/N" @change="afterChangeToRow(scope)"></el-input>
					</span>
                    <span v-else>
						{{ scope.row.pur_quotation_flag}}
					</span>
                </template>
            </el-table-column>

            <el-table-column :class-name="fmtComboxList('iss_flag')" prop='iss_flag' :label="$t('getapi[8149]')"
                             title='外协有无(-不需要,Yes,No)' sortable="custom">
                <template scope="scope">
					<span v-if="comboxList.value == 'iss_flag'">
						<el-input class-name="check" size="small" v-model="scope.row.iss_flag" placeholder="Y/-/N"
                                  @change="afterChangeToRow(scope)"></el-input>
					</span>
                    <span v-else>
						{{ scope.row.iss_flag}}
					</span>
                </template>
            </el-table-column>
            <el-table-column :class-name="fmtComboxList('iss_quotation_flag')"
                             prop='iss_quotation_flag' :label="$t('getapi[451]')" title='外协价表(-不需要,Yes,No)' sortable="custom">
                <template scope="scope">
					<span v-if="comboxList.value == 'iss_quotation_flag'">
						<el-input class-name="check" size="small" v-model="scope.row.iss_quotation_flag"
                                  placeholder="Y/-/N" @change="afterChangeToRow(scope)"></el-input>
					</span>
                    <span v-else>
						{{ scope.row.iss_quotation_flag}}
					</span>
                </template>
            </el-table-column>

            <el-table-column :class-name="fmtComboxList('sales_part')" prop='sales_part'
                             :label="$t('getapi[2800]')" title='销售件号' width="120" sortable="custom">
                <template scope="scope">
					<span v-if="comboxList.value == 'sales_part'">
						<el-input class-name="check" size="small" v-model="scope.row.sales_part"
                                  @change="afterChangeToRow(scope)"></el-input>
					</span>
                    <span v-else>
						{{ scope.row.sales_part}}
					</span>
                </template>
            </el-table-column>

            <el-table-column :class-name="fmtComboxList('remark1')" prop='remark1' :label="$t('getapi[8151]')"
                             title='备注1' sortable="custom">
                <template scope="scope">
					<span v-if="comboxList.value == 'remark1'">
						<el-input class-name="check" size="small" v-model="scope.row.remark1"
                                  @change="afterChangeToRow(scope)"></el-input>
					</span>
                    <span v-else>
						{{ scope.row.remark1}}
					</span>
                </template>
            </el-table-column>
            <el-table-column :class-name="fmtComboxList('remark2')" prop='remark2' :label="$t('getapi[8154]')"
                             title='备注2' sortable="custom">
                <template scope="scope">
					<span v-if="comboxList.value == 'remark2'">
						<el-input class-name="check" size="small" v-model="scope.row.remark2"
                                  @change="afterChangeToRow(scope)"></el-input>
					</span>
                    <span v-else>
						{{ scope.row.remark2}}
					</span>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop='line_status_text' :label="$t('getapi[8160]')" title='评估状态描述' width="120"
                             sortable="custom"></el-table-column>

            <el-table-column show-overflow-tooltip prop='part_version' :label="$t('getapi[8739]')" title='伟泰料号版本'
                             sortable="custom"></el-table-column>
            <el-table-column show-overflow-tooltip prop='routing_version' :label="$t('getapi[547]')" title='伟泰工艺版本'
                             sortable="custom"></el-table-column>
            <el-table-column show-overflow-tooltip prop='part_name' :label="$t('getapi[116]')" title='伟泰物料名称' width="140"
                             sortable="custom"></el-table-column>
            <el-table-column show-overflow-tooltip prop='remark_status' :label="$t('getapi[8740]')" title='复制信息' width="120"
                             sortable="custom"></el-table-column>

            <el-table-column show-overflow-tooltip prop='create_person' :label="$t('getapi[410]')" title='创建人'
                             sortable="custom"></el-table-column>
            <el-table-column show-overflow-tooltip prop='create_time' :label="$t('getapi[135]')" title='创建时间' width="120"
                             sortable="custom"></el-table-column>
            <el-table-column show-overflow-tooltip prop='modify_person' :label="$t('getapi[733]')" title='修改人'
                             sortable="custom"></el-table-column>
            <el-table-column show-overflow-tooltip prop='modify_time' :label="$t('getapi[1210]')" title='修改时间' width="120"
                             sortable="custom"></el-table-column>
            <el-table-column show-overflow-tooltip prop='sd_person' :label="$t('getapi[8150]')" title='开发更新人'
                             sortable="custom"></el-table-column>
            <el-table-column show-overflow-tooltip prop='sd_time' :label="$t('getapi[6265]')" title='开发更新时间' width="120"
                             sortable="custom"></el-table-column>
            <el-table-column show-overflow-tooltip prop='pur_person' :label="$t('getapi[8152]')" title='采购更新人'
                             sortable="custom"></el-table-column>
            <el-table-column show-overflow-tooltip prop='pur_time' :label="$t('getapi[6265]')" title='采购更新时间' width="120"
                             sortable="custom"></el-table-column>
            <el-table-column show-overflow-tooltip prop='mould_person' :label="$t('getapi[8741]')" title='模具更新人'
                             sortable="custom"></el-table-column>
            <el-table-column show-overflow-tooltip prop='mould_time' :label="$t('getapi[6265]')" title='模具更新时间' width="120"
                             sortable="custom"></el-table-column>
            <el-table-column show-overflow-tooltip prop='produce_person' :label="$t('getapi[8157]')" title='制造更新人'
                             sortable="custom"></el-table-column>
            <el-table-column show-overflow-tooltip prop='produce_time' :label="$t('getapi[6265]')" title='制造周更新时间' width="120"
                             sortable="custom"></el-table-column>

            <!-- <el-table-column show-overflow-tooltip prop='relation_partmaster_id' label='伟泰料号唯一号' title='伟泰料号唯一号'></el-table-column> -->
            <!-- <el-table-column show-overflow-tooltip prop='mould_flag' label='需要模具' title='工装模具(-不需要,Yes,No)'>
                            <el-table-column show-overflow-tooltip prop='purchase_flag' label='采购标记' title='采购标记'></el-table-column>
            <el-table-column show-overflow-tooltip prop='produce_flag' label='制造标记' title='制造标记'></el-table-column>

                -->

            <el-table-column fixed="right" :label="$t('getapi[6048]')" width="90">
                <!-- 编辑删除 -->
                <template slot-scope="scope">
                    <el-button :disabled="!btn.edit" @click.native.prevent="dialog_edit(scope)" type="text" size="mini">
                        {{ $t('getapi[34]') }}
                    </el-button>
                    <el-button :disabled="!btn.edit" @click.native.prevent="dialog_del(scope)" type="text" size="mini">
                        {{ $t('getapi[40]') }}
                    </el-button>
                </template>
            </el-table-column>
            <!-- <el-popconfirm :confirmButtonText="$t('getapi[6109]')" :cancelButtonText="$t('getapi[6]')" icon="el-icon-info" iconColor="red" :title="$t('getapi[637]')" @onConfirm="del(scope)">
                <el-button :disabled="!btn.del" slot="reference" type="text" size="mini">{{ $t('getapi[40]') }}</el-button>
            </el-popconfirm> -->

        </el-table>
        <!-- 表格 -->
        <!-- 分页 -->
        <el-row class="page">
            <el-col :span="12">
                <el-pagination @size-change="handleSizeChange"
                               @current-change="handleCurrentChange" :page-sizes="[50, 100, 200, 300, 400]"
                               :page-size="PageSize" background layout="total, sizes, prev, pager, next, jumper"
                               :total="total">
                </el-pagination>
            </el-col>
            <el-col :span="12">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{DbTbNames}}
                </div>
            </el-col>
        </el-row>
        <!-- 分页 -->
        <!-- 搜索弹框 -->
        <serce :isVisible="isVisible" queryData="ENG_NewProduct" ref="ser" @getser="serclick"></serce>
        <!-- 搜索弹框 -->

        <!-- 编辑弹框 -->
        <el-dialog v-dialogDrag :visible.sync="editvisi" :title="$t('getapi[34]')+'-'+formInline.relation_order_no" width="980px"
                   :close-on-click-modal="false">
            <el-form :inline="true" :model="formInline" class="demo-form-inline" label-width="68px"
                     label-position="left" size="small">
                <el-form-item :label="$t('getapi[1297]')">
                    <el-input v-model="formInline.sort_id" type="number" autocomplete="off" title=""
                              @mousewheel.native.prevent></el-input>
                </el-form-item>
                <el-form-item :label="$t('getapi[8146]')">
                    <el-input v-model="formInline.part_code" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item :label="$t('getapi[6117]')">
                    <el-input placeholder="" v-model="formInline.mp_text" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item :label="$t('getapi[8147]')">
                    <el-select v-model="formInline.routing_flag">
                        <el-option v-for="item in comboxYesNo" :key="item.key" :label="item.label"
                                   :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <br/>
                <el-form-item :label="$t('getapi[8148]')">
                    <el-input v-model="formInline.level_no" type="number" autocomplete="off" title=""
                              @mousewheel.native.prevent></el-input>
                </el-form-item>
                <el-form-item :label="$t('getapi[4347]')">
                    <el-input v-model="formInline.std_qty" type="number" autocomplete="off" title=""
                              @mousewheel.native.prevent></el-input>
                </el-form-item>
                <el-form-item :label="$t('getapi[2800]')">
                    <el-input v-model="formInline.sales_part"></el-input>
                </el-form-item>
                <el-form-item :label="$t('getapi[552]')">
                    <el-input placeholder="状态(生成、已评估）" v-model="formInline.line_status" :disabled="true"></el-input>
                </el-form-item>
                <br/>
                <hr/>
                <el-form-item :label="$t('getapi[449]')">
                    <el-select v-model="formInline.pur_quotation_flag">
                        <el-option v-for="item in comboxYesNo" :key="item.key" :label="item.label"
                                   :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('getapi[8149]')">
                    <el-select v-model="formInline.iss_flag">
                        <el-option v-for="item in comboxYesNo" :key="item.key" :label="item.label"
                                   :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('getapi[451]')">
                    <el-select v-model="formInline.iss_quotation_flag">
                        <el-option v-for="item in comboxYesNo" :key="item.key" :label="item.label"
                                   :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="editShowSave">
                    <el-button size="small" @click="dialog_sava('开发更新')" :loading="loading" :disabled="loading"
                               type="primary">{{$t('getapi[8150]')}}
                    </el-button>
                </el-form-item>
                <br/>
                <hr/>
                <el-form-item :label="$t('getapi[1520]')">
                    <el-input v-model="formInline.leadtime_purchase"></el-input>
                </el-form-item>
                <el-form-item :label="$t('getapi[8151]')" style="width: 320px;">
                    <el-input v-model="formInline.remark1" class="myWidth"></el-input>
                </el-form-item>

                <el-form-item v-if="editShowSave">
                    <el-button size="small" @click="dialog_sava('采购更新')" :loading="loading" :disabled="loading"
                               type="primary">{{$t('getapi[8152]')}}
                    </el-button>
                </el-form-item>
                <br/>
                <hr/>
                <el-form-item :label="$t('getapi[8153]')">
                    <el-select v-model="formInline.mould_text">
                        <el-option label="" value=""></el-option>
                        <el-option :label="$t('getapi[561]')" value="是"></el-option>
                        <el-option :label="$t('getapi[866]')" value="否"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('getapi[8138]')">
                    <el-input v-model="formInline.leadtime_mold"></el-input>
                </el-form-item>
                <el-form-item :label="$t('getapi[8154]')" style="width: 320px;">
                    <el-input v-model="formInline.remark2" class="myWidth"></el-input>
                </el-form-item>

                <el-form-item v-if="editShowSave">
                    <el-button size="small" @click="dialog_sava('模具更新')" :loading="loading" :disabled="loading"
                               type="primary">{{$t('getapi[8155]')}}
                    </el-button>
                </el-form-item>
                <br/>
                <hr/>
                <el-form-item :label="$t('getapi[8137]')">
                    <el-input v-model="formInline.leadtime_produce"></el-input>
                </el-form-item>
                <el-form-item :label="$t('getapi[8156]')">
                    <el-input v-model="formInline.leadtime_line" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item v-if="editShowSave">
                    <el-button size="small" @click="dialog_sava('制造更新')" :loading="loading" :disabled="loading"
                               type="primary">{{$t('getapi[8157]')}}
                    </el-button>
                </el-form-item>
                <br/>
                <span style="padding: 9px;">{{$t('getapi[8158]')}}</span>
                <br/>
                <hr/>

                <el-form-item :label="$t('getapi[410]')" label-width="80px">
                    <el-input v-model="formInline.create_person" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item :label="$t('getapi[135]')">
                    <el-input v-model="formInline.create_time" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item :label="$t('getapi[547]')">
                    <el-input v-model="formInline.routing_version" :disabled="true"></el-input>
                </el-form-item>
                <br/>
                <el-form-item :label="$t('getapi[733]')" label-width="80px">
                    <el-input v-model="formInline.modify_person" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item :label="$t('getapi[1210]')">
                    <el-input v-model="formInline.modify_time" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item :label="$t('getapi[116]')" style="width: 320px;">
                    <el-input v-model="formInline.part_name" :disabled="true"
                              class="myWidth"></el-input>
                </el-form-item>
                <br/>
                <el-form-item :label="$t('getapi[8159]')" label-width="80px">
                    <el-input v-model="formInline.sd_person" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item :label="$t('getapi[6265]')">
                    <el-input v-model="formInline.sd_time" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item :label="$t('getapi[8160]')" style="width: 320px;">
                    <el-input v-model="formInline.line_status_text" :disabled="true"
                              class="myWidth"></el-input>
                </el-form-item>
                <!-- <el-form-item label="复制信息">
                    <el-input placeholder="复制信息" v-model="formInline.remark_status" readonly></el-input>
                </el-form-item> -->
                <br/>
                <el-form-item :label="$t('getapi[8161]')" label-width="80px">
                    <el-input placeholder="采购更新人" v-model="formInline.pur_person" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item :label="$t('getapi[6265]')">
                    <el-input placeholder="采购更新时间" v-model="formInline.pur_time" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item :label="$t('getapi[8162]')">
                    <el-input placeholder="采购标记" v-model="formInline.purchase_flag" :disabled="true"></el-input>
                </el-form-item>
                <br/>
                <el-form-item :label="$t('getapi[8163]')" label-width="80px">
                    <el-input placeholder="工装模具更新人" v-model="formInline.mould_person" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item :label="$t('getapi[6265]')">
                    <el-input placeholder="工装模具更新时间" v-model="formInline.mould_time" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item :label="$t('getapi[8164]')">
                    <el-input placeholder="模具标记" v-model="formInline.mould_flag" :disabled="true"></el-input>
                </el-form-item>
                <br/>
                <el-form-item :label="$t('getapi[8165]')" label-width="80px">
                    <el-input placeholder="制造周期更新人" v-model="formInline.produce_person" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item :label="$t('getapi[6265]')">
                    <el-input placeholder="制造周期更新时间" v-model="formInline.mould_time" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item :label="$t('getapi[8166]')">
                    <el-input placeholder="制造标记" v-model="formInline.produce_flag" :disabled="true"></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
				<!-- <el-button v-if="editShowSave" @click="dialog_sava" :loading="loading" :disabled="loading" type="primary">{{ $t('getapi[937]') }}</el-button> -->
				<el-button @click="dialog_cancel">{{ $t('getapi[6]') }}</el-button>
				<el-button v-if="editShowSave" @click="dialog_sava('工程师更新')" :loading="loading" :disabled="loading"
                           type="primary">{{$t('getapi[937]')}}</el-button>
			</span>
        </el-dialog>
        <!-- 编辑弹框 -->
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import urlpost from '@/api/config.js';

    let _YesNo = [
        {key: 1, lable: "-", value: "-"},
        {key: 2, lable: "Y", value: "Y"},
        {key: 3, lable: "N", value: "N"},
        {key: 4, lable: "", value: ""},
    ];
    export default {
        name: 'npplan',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight-180
            }
        },
        data() {
            return {
                formInline: {
                    order_no: null,
                    order_status: null,
                    sort_id: null,
                    csr_orderno: null,
                    csr_lineno: null,
                    csr_partcode: null,
                    csr_qty: null,
                    csr_id: null,
                    csr_deliverydate: null,
                    csr_orderdate: null,
                    csr_name: null,
                    pm_name: null,
                    pe_name: null,
                    pp_name: null,
                    pm_email: null,
                    pe_email: null,
                    pp_email: null,
                    part_flag: null,
                    leadtime_total: null,
                    leadtime_purchase: null,
                    leadtime_mold: null,
                    leadtime_produce: null,
                    sales_flag: null,
                    delivery_date: null,
                    remark1: null,
                    remark2: null,
                    create_person: null,
                    create_time: null,
                    modify_person: null,
                    modify_time: null,
                    pm_person: null,
                    pm_time: null,
                    pe_person: null,
                    pe_time: null,
                    sd_person: null,
                    sd_time: null,
                    pur_person: null,
                    pur_time: null,
                    mould_person: null,
                    mould_time: null,
                    produce_person: null,
                    produce_time: null,
                },
                formLineScope: null,

                dataSet: [],	//表格-数据
                DbTbNames: '', //表格-表名
                PageIndex: 1,	//表格-页标
                PageSize: this.$http.getPageSize('npplan'),	//表格-页大小
                SelectIndex: 0,	//表格-页标
                total: 0, // 表格-数据总量
                loading: false, // 表格-加载状态
                selectData: [], // 多选数组
                isVisible: false,// 搜索弹框
                queryData: [], // 查询数组
                editvisi: false,	//编辑对话框-是否显示
                editShowSave: false,		//编辑对话框-保存按钮
                btn: {
                    del: false,
                    edit: false
                },
                comboxYesNo: _YesNo,
                comboxList: {
                    value: '',
                    Rows: [
                        {type: '', value: '', label: '请选择'},
                        {type: '工程师', value: 'level_no', label: '层级'},
                        {type: '工程师', value: 'std_qty', label: 'BOM用量'},
                        {type: '模具', value: 'mould_text', label: '需要模具'},
                        {type: '采购', value: 'leadtime_purchase', label: '采购周期'},
                        {type: '制造', value: 'leadtime_produce', label: '制造周期'},
                        {type: '模具', value: 'leadtime_mold', label: '模具周期'},
                        {type: '工程师', value: 'routing_flag', label: '工艺有无'},
                        {type: '开发', value: 'pur_quotation_flag', label: '采购价表'},
                        {type: '开发', value: 'iss_flag', label: '外协有无'},
                        {type: '开发', value: 'iss_quotation_flag', label: '外协价表'},
                        {type: '工程师', value: 'sales_part', label: '销售件号'},
                        {type: '采购', value: 'remark1', label: '采购备注'},
                        {type: '模具', value: 'remark2', label: '模具备注'},
                    ]
                },
            };
        },
        create() {
        },
        beforeMount() {
            // console.log('----beforeMount---');
            // let that = this;
            // that.getqwlist();
            // urlpost.urlpost('Basic/GetShopGroupList', {}, function (res) {
            // 	console.log(res);
            // 	if (res.Success) {
            // 		that.ShopGroupList = res.DataContent;
            // 	}
            // });
            // urlpost.urlpost('Basic/WH/GetCalendarDropDown', {}, function (res) {
            // 	console.log(res);
            // 	if (res.Success) {
            // 		that.CalendarDropDown = res.DataContent;
            // 	}
            // });
        },
        mounted() {
            let that = this;
            that.getView();
            that.authority();
            that.$nextTick(function () {
                that.$processdata.initForm()
            })
        },
        methods: {
            authority() {
                //按钮操作权限
                let that = this;

                if (that.selectData.length > 0) {
                    that.$refs.SetBtn.SetButtonEnable('import,search,refresh,export,del');
                }
                else {
                    that.$refs.SetBtn.SetButtonEnable('import,search,refresh,export');
                }
                that.btn.edit = true;
                that.btn.del = true;
            },
            search() {
                // 查询
                this.isVisible = true;
                this.$refs.ser.clearInput(this.isVisible, 'ENG_NewProduct_Line');
            },
            serclick(val) {
                // 查询对话框
                let that = this;
                that.queryData = val;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            handleSizeChange(val) {
                //修改页数
                this.PageSize = val;
                this.$http.savePageSize('npplan',val)
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                //跳页
                this.PageIndex = val;
                this.getView();
                this.authority();
            },
            handleSelectionChange(selection) {
                console.log('----handleSelectionChange---', selection);
                // 选择行
                this.selectData = selection;
                this.authority();
            },
            reflash() {
                // 刷新
                this.comboxList.value = '';
                this.getView();
            },
            getView() {
                // 获取数据
                let that = this;
                that.loading = true;
                this.isVisible = false;

                let data = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Param: []
                };
                for (let i = 0; i < that.queryData.length; i++) {
                    if (!that.queryData[i].query_sort && !that.queryData[i].query_Condition) {
                        continue;
                    }
                    data.Param.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                that.$http.urlpost('/Eng/NewProduct/Part/DataList', data, function (res) {
                    that.loading = false;
                    if (res.Success) {
                        that.dataSet = res.DataContent
                        that.total = res.Totals
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.$nextTick(function(){
                        that.$processdata.initForm(that.SelectIndex)
                    });
                    that.authority();
                });
            },
            exp() {
                //导出
                let that = this;
                that.loading = true;
                let data = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Param: []
                };
                for (let i = 0; i < that.queryData.length; i++) {
                    data.Param.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].query_field_type,
                        query_field_name: that.queryData[i].query_field_name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                that.$http.urlpost('/Eng/NewProduct/Part/ToExecl', data, function (res) {
                    that.loading = false;
                    if (res.Success) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            imp() {
                // 导入 零件清单
                let item = {label: '通用导入', name: 'exp', path: '/exp/41', url: '/exp/41', icon: 'video-play'};
                this.$router.push({path: '/exp/41'});
                this.$store.commit('selectMenu', item);
            },

            add() {
                // 对话框-新增 记录
                let r1 = this.formInline;
                for (var key in r1) {
                    r1[key] = null;
                }
                this.editvisi = true;
            },
            cellDBClick(row, column, cell, event) {
                // 编辑
                // console.log('-------cellDBClick---------',row, column, cell, event);
                let that = this;
                that.authority();
            },
            dialog_show(jsd) {
                this.formLineScope = jsd;
                this.formInline = JSON.parse(JSON.stringify(jsd.row));
                this.editvisi = true;
                this.editShowSave = false;

            },
            dialog_check(text) {

            },
            dialog_sava(text) {
                // 保存数据
                let that = this;
                let parm = {UpdateText: text, Rows: [that.formInline]};

                that.loading = true;
                that.$http.urlpost('/Eng/NewProduct/Part/Save', parm, function (res) {
                    that.loading = false;

                    if (res.Success) {
                        that.$message.success(that.$t('getapi[284]'));

                        if (that.formLineScope) {
                            that.dataSet.splice(that.formLineScope.$index, 1, res.DataContent[0]);
                            that.formInline = res.DataContent[0];
                        }
                        if (text == '工程师更新') {
                            that.editvisi = false;
                        }
                    }
                    else {
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            },
            dialog_edit(jsd) {
                // 编辑对话框
                this.dialog_show(jsd);
                this.editShowSave = true;
            },
            dialog_cancel() {
                this.formLineScope = null;
                this.editvisi = false;
            },
            delall() {
                //批量选择的记录
                let that = this;
                if (!that.selectData) {
                    return;
                }
                if (that.selectData.length == 0) {
                    return;
                }
                // selectData 未存储index, index: that.selectData.$index
                let rows = [];
                for (var i = 0; i < that.selectData.length; i++) {
                    rows.push({order_no: that.selectData[i].order_no, modify_time: that.selectData[i].modify_time});
                }
                //
                this.delete_rows(rows, function () {
                    that.selectData = [];
                    that.reflash();
                    // // 批量删除后移除记录
                    // that.selectData = [];
                    // that.$refs.multipleTable.clearSelection();
                    // rows.sort(function (a, b) {
                    // 	return b.index - a.index;
                    // }).forEach(function (e) {
                    // 	console.log('----------', e.index);
                    // 	that.dataSet.splice(e.index, 1);
                    // 	return;
                    // });
                });
            },

            dialog_del(jsd) {
                // 对话框删除数
                if (!jsd) {
                    return;
                }
                if (!jsd.row) {
                    return;
                }
                let that = this;
                let rows = [jsd.row];
                this.delete_rows(rows, function () {
                    that.dataSet.splice(jsd.$index, 1);
                });
            },
            delete_rows(rows, callback) {
                let that = this;
                if (!rows) {
                    return;
                }
                if (rows.length == 0) {
                    return;
                }
                let parm = [];
                for (var i = 0; i < rows.length; i++) {
                    parm.push({exclusively_id: rows[i].exclusively_id, modify_time: rows[i].modify_time});
                }
                let msg = '此操作将永久删除该数据, 是否继续?';
                if (rows.length == 1) {
                    msg = msg + '</p>' + rows[0].relation_order_no + ',' + rows[0].part_code;
                }
                else {
                    msg = msg + '</p>已选择的' + rows.length + '笔记录';
                }
                this.$confirm(msg, that.$t('getapi[194]'), {
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning',
                    dangerouslyUseHTMLString: true
                }).then(() => {
                    that.$http.urlpost('/Eng/NewProduct/Part/Delete', parm, function (res) {
                        if (res.Success) {
                            callback();
                        }
                        else {
                            that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                        }
                    });
                }).catch(() => {
                    // this.$message({
                    //   type: 'info',
                    //   message: '已取消删除'
                    // });
                });

            },
            myformatter(row, column, cellValue, index) {
                // if (index == 0) {
                // 	console.log('----', row, column, cellValue);
                // }
                if (!cellValue) {
                    return cellValue;
                }
                if (cellValue.length < 10) {
                    return cellValue;
                }
                return cellValue.substr(0, 10);
            },
            sortChange(column) {
                let that = this
                let name = column.prop
                console.log(column)
                if (column.order == "ascending") {
                    let compare = function (obj1, obj2) {
                        let val1 = obj1[name];
                        let val2 = obj2[name];
                        if (val1 < val2) {
                            return -1;
                        } else if (val1 > val2) {
                            return 1;
                        } else {
                            return that.dataSet.indexOf(obj1) - that.dataSet.indexOf(obj2);
                        }
                    }
                    that.dataSet = that.dataSet.sort(compare);
                } else if (column.order == "descending") {
                    let compare = function (obj1, obj2) {
                        let val1 = obj1[name];
                        let val2 = obj2[name];
                        if (val1 < val2) {
                            return 1;
                        } else if (val1 > val2) {
                            return -1;
                        } else {
                            return that.dataSet.indexOf(obj2) - that.dataSet.indexOf(obj1);
                        }
                    }
                    that.dataSet = that.dataSet.sort(compare);
                }
            },
            fmtComboxList(val) {
                if (!val || !this.comboxList) {
                    return '';
                }
                if (val == this.comboxList.value) {
                    return 'check';
                }
                return '';
            },
            afterChangeToRow(scope) {
                console.log('-----afterChangeToRow--', scope);
                if (!scope) {
                    return;
                }
                if (!scope.row) {
                    return;
                }
                //let i = scope.$index;
                this.$refs.multipleTable.toggleRowSelection(scope.row, true);
            },
            updateComboxList() {
                // 批量更新
                let that = this;
                if (!that.selectData) {
                    return;
                }
                if (that.selectData.length == 0) {
                    that.$message.error("请选择需要批量更新的记录");
                    return;
                }

                let arrList = that.comboxList.Rows;
                let arrValue = that.comboxList.value;
                let parm = {Column: null, Rows: that.selectData};
                for (let i = 0; i < arrList.length; i++) {
                    if (arrList[i].value == arrValue) {
                        parm.Column = arrList[i];
                        break;
                    }
                }
                console.log('-----', parm);
                if (!parm.Column) {
                    that.$message.error("获取更新类别失败，不能批量更新！");
                    return;
                }
                let msg = "请确认是否要更新选择的数据？<br/>已选择:" + parm.Rows.length + "笔";
                this.$confirm(msg, that.$t('getapi[194]'), {
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning',
                    dangerouslyUseHTMLString: true
                }).then(() => {
                    that.loading = true;
                    that.$http.urlpost('/Eng/NewProduct/Part/BatchSave', parm, function (res) {
                        that.loading = false;

                        if (res.Success) {
                            that.$message.success(that.$t('getapi[284]'));
                            //
                            that.reflash();
                        }
                        else {
                            that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                        }
                    });
                }).catch(() => {
                    console.log('--catch--');
                });

            },
            // toggleSelection(rows) {
            // 	if (rows) {
            // 		rows.forEach(row => {
            // 			this.$refs.dataSet.toggleRowSelection(row);
            // 		});
            // 	} else {
            // 		this.$refs.dataSet.clearSelection();
            // 	}
            // }
        }
    };
</script>

<style scoped lang="less">
    /**/
    .el-form-item {
        margin-top: 1px;
        margin-bottom: 1px;
        margin-left: 9px;
    }

    .myWidth {
        width: 300px;
    }

    /deep/ .el-form-item__label {
        padding-right: 6px;
    }

    /deep/ .el-form-item__content {
        width: 125px;
    }

    /deep/ .el-form-item__content input.el-input__inner {
        max-width: 250px;
    }

    /* /deep/	.el-form-item--small {
        width: 300px;
    }  */
</style>